"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const CheckBox = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.05-10.519L6.71 9.424 4.95 7.826a.592.592 0 0 0-.783 0 .492.492 0 0 0 0 .739l2.151 1.954a.592.592 0 0 0 .783 0l4.732-4.298a.492.492 0 0 0 0-.74.592.592 0 0 0-.784 0z"
}));
var _default = exports.default = CheckBox;